import { Action } from 'redux';
import { Groups, ModelData } from '@ikea-aoa/component-view-3d';
import { ModelsData } from 'sofa-reborn-react';

// State
export interface ModelsState {
	sofaGroups: Groups;
	sofaModels: ModelData;
}

// Actions
export const SET_MODELS = 'SET_MODELS';

interface SetModels extends Action {
	type: typeof SET_MODELS;
	value: ModelsData;
}

export type ModelsStateActions = SetModels;
